<!-- eslint-disable no-undef -->
<template>
  <div :class="{'ckeditor--incard': incard}" class="ckeditor">
    <div v-if="title !== null" class="ckeditor__label" v-html="title"></div>
    <textarea :id="id" :value="value"></textarea>
  </div>
</template>
<script>
/* eslint-disable vue/name-property-casing,no-undef */

import { debounce, isNil } from 'lodash';

export default {
  name: 'ckeditor',
  props: {
    value: {
      type: String,
    },
    id: {
      type: String,
      default: 'editor',
    },
    height: {
      type: String,
      default: '90px',
    },
    extraplugins: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
    incard: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      debouncedFireInputEvent: null,
    };
  },

  computed: {
    language: function () {
      return this.$shortLocale;
    },
  },
  created() {
    this.debouncedFireInputEvent = debounce(this.fireInputEvent, 750);
  },
  beforeUpdate() {
    const ckeditorId = this.id;
    try {
      if (!isNil(CKEDITOR.instances[ckeditorId]) && this.value !== CKEDITOR.instances[ckeditorId].getData()) {
        CKEDITOR.instances[ckeditorId].setData(this.value);
      }
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  beforeDestroy() {
    const ckeditorId = this.id;
    try {
      if (!isNil(CKEDITOR.instances[ckeditorId])) {
        CKEDITOR.instances[ckeditorId].destroy();
      }
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  mounted() {
    const ckeditorId = this.id;
    const ckeditorConfig = {
      language: this.language,
      height: this.height,
      extraPlugins: 'clipboard,image,link,magicline,table,tabletools,justify', // ,${this.extraplugins}`,
      // removePlugins: 'elementspath',
      resize_enabled: false,
      allowedContent: true,
      removeFormatAttributes: '',
      extraAllowedContent: '*(*);*{*}',
    };
    try {
      CKEDITOR.replace(ckeditorId, ckeditorConfig);
      CKEDITOR.instances[ckeditorId].setData(this.value);
      CKEDITOR.instances[ckeditorId].on('change', () => {
        this.debouncedFireInputEvent(ckeditorId);
      });
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  destroyed() {
    const ckeditorId = this.id;
    try {
      if (CKEDITOR.instances[ckeditorId]) {
        CKEDITOR.instances[ckeditorId].destroy();
      }
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  methods: {
    fireInputEvent(ckeditorId) {
      try {
        const ckeditorData = CKEDITOR.instances[ckeditorId].getData();
        if (ckeditorData !== this.value) {
          this.$emit('input', ckeditorData);
        }
        // eslint-disable-next-line no-empty
      } catch (e) { }
    },
  },
};
</script>

<style lang="scss">
  @import '~styles/import';

  a.cke_button {
    height: 26px!important;
  }

  .ckeditor {
    position: relative;
    padding-top: 6px;
    padding-bottom: 14px;
    margin-bottom: 6px;

    &.ckeditor--incard {
      padding-top: 0;
      padding-bottom: 0;
      margin-bottom: 0;

      > div {
        border-radius: 0rem!important;
      }

      .cke_inner {
        border-radius: 0rem;
      }

      .cke_top {
        border-top-left-radius: 0rem;
        border-top-right-radius: 0rem;
      }
      .cke_bottom {
        border-bottom-left-radius: 0rem;
        border-bottom-right-radius: 0rem;
      }
    }

    &__label {
      position: absolute;
      color: #7a7f7e;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
      z-index: 2;
      pointer-events: none;
      background-color: #ffffff;
      padding: 0 0.4rem;
      border-radius: 0.3rem;
      will-change: top, font-size;
      max-width: 100%;
      top: 0;
      left: 0.6rem;
      font-size: 1.1rem;
    }
  }

  .ckeditor > div {
    border-radius: 0.3rem;
    border-color: $middlegray;
  }

  .cke_inner {
    border-radius: 0.3rem;
  }

  .cke_top {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }
  .cke_bottom {
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/ckeditor.vue